/* eslint-disable no-unused-vars */

import { makeStyles } from "@mui/styles";
import Add from "@mui/icons-material/Add";
import DebitIcon from "@mui/icons-material/CallMade";
import CreditIcon from "@mui/icons-material/CallReceived";
import PrecisionManufacturingSharpIcon from "@mui/icons-material/PrecisionManufacturingSharp";
import ListIcon from "@mui/icons-material/ListAlt";
import styles from "../../assets/jss/material-dashboard-react/views/dashboardStyle.js";
import Card from "../../components/Card/Card.js";
import CardFooter from "../../components/Card/CardFooter.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardIcon from "../../components/Card/CardIcon.js";
import InventorySharpIcon from "@mui/icons-material/InventorySharp";
import ImportExportSharpIcon from "@mui/icons-material/ImportExportSharp";
import { Grid } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import InventoryAdjustmentMultipleItem from "./inventory-adjustment/InventoryAdjustmentMultipleItem";
import PurchaseRequestDraftWindow from "./purchase-request/purchase-reqest-draft/PurchaseRequestDraftWindow";
import QuickPurchaseRequestWindow from "./purchase-request/quick-purchase-request/QuickPurchaseRequestWindow";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ProductionCrud from "./production/productionCrud.jsx";
import { useState } from "react";
const useStyles = makeStyles(styles);

export default function PurchaseOrderDashBoard(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const translate = t;
  const [showProductionCrud, setShowProductionCrud] = useState(false);
  const [mode, setMode] = useState("");
  const [from, setFrom] = useState("");

  var biRef = {};
  useEffect(() => {}, []);
  function purchaseorderListRefresh() {}

  return (
    <div>
      <Grid container spacing={"5px"} style={{ marginTop: "10px" }}>
        {props.context.privileges.purchase_sub_menu_purchase_entry && (
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <CreditIcon />
                </CardIcon>
                <p className={classes.cardCategory}>
                  {translate("Purchase Entry")}
                </p>
                <h3 className={classes.cardTitle}></h3>
              </CardHeader>
              <CardFooter stats>
                <Grid container>
                  {
                    <Grid item xs={12} sx={{ marginTop: "10px" }}>
                      <div className={classes.stats}>
                        <Add />
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={(e) => props.changeView("LPO_CREATE")}
                        >
                          {translate("Local Purchase Order ")}
                        </a>
                      </div>
                    </Grid>
                  }
                  {
                    <Grid item xs={12} sx={{ marginTop: "10px" }}>
                      <div className={classes.stats}>
                        <Add />
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={(e) => props.changeView("GRN_NEW")}
                        >
                          {translate("Goods Receive Note ")}
                        </a>
                      </div>
                    </Grid>
                  }
                  {
                    <Grid item xs={12} sx={{ marginTop: "10px" }}>
                      <div className={classes.stats}>
                        <ListIcon />
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={(e) => props.changeView("PO_LIST_N")}
                        >
                          {translate("View List ")}
                        </a>
                      </div>
                    </Grid>
                  }
                </Grid>
              </CardFooter>
            </Card>
          </Grid>
        )}
        {props.context.privileges.purchase_sub_menu_purchase_return_entry && (
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardHeader color="warning" stats icon>
                <CardIcon color="warning">
                  <DebitIcon />
                </CardIcon>
                <p className={classes.cardCategory}>
                  {translate("Return Entry")}
                </p>
                <h3 className={classes.cardTitle}></h3>
              </CardHeader>
              <CardFooter stats>
                <Grid container>
                  <Grid item xs={12} sx={{ marginTop: "10px" }}>
                    {" "}
                    <div className={classes.stats}>
                      <Add />
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={(e) => props.changeView("GRV_NEW")}
                      >
                        {translate("Goods Return Voucher")}
                      </a>
                    </div>
                  </Grid>

                  <Grid item xs={12} sx={{ marginTop: "10px" }}>
                    <div className={classes.stats}>
                      <ListIcon />
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={(e) => props.changeView("PR_LIST_N")}
                      >
                        {translate("View List ")}
                      </a>
                    </div>
                  </Grid>
                </Grid>
              </CardFooter>
            </Card>
          </Grid>
        )}
        {props.context.privileges.purchase_sub_menu_inventory_adjustment && (
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <InventorySharpIcon />
                </CardIcon>
                <p className={classes.cardCategory}>
                  {translate("Inventory Adjustment")}
                </p>
                <h3 className={classes.cardTitle}></h3>
              </CardHeader>
              <CardFooter stats>
                <Grid container>
                  <Grid item xs={13} sx={{ marginTop: "10px" }}>
                    <div className={classes.stats}>
                      <Add />
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={(e) =>
                          biRef.multipleItemAdjustment.showInventoryAdjustmentMultipleItem()
                        }
                      >
                        {translate("Inventory Adjustment - Multiple")}
                      </a>
                    </div>
                  </Grid>

                  <Grid item xs={12} sx={{ marginTop: "10px" }}>
                    <div className={classes.stats}>
                      <ListIcon />
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={(e) => props.changeView("IV_DRAFT_LIST")}
                      >
                        {translate("Inventory Adjustment -  Draft List")}
                      </a>
                    </div>
                  </Grid>

                  <Grid item xs={12} sx={{ marginTop: "10px" }}>
                    <div className={classes.stats}>
                      <ListIcon />
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={(e) => props.changeView("IA_LIST")}
                      >
                        {translate("Itemwise Adjustment")}
                      </a>
                    </div>
                  </Grid>
                  <Grid item xs={12} sx={{ marginTop: "10px" }}>
                    <div className={classes.stats}>
                      <ListIcon />
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={(e) => props.changeView("IV_HISTORY")}
                      >
                        {translate("Inventory Adjustment History")}
                      </a>
                    </div>
                  </Grid>
                </Grid>
              </CardFooter>
            </Card>
          </Grid>
        )}
        {(props.context.store.shopType === "BRANCH" ||
          (props.context.store.shopType === "WAREHOUSE" &&
            props.context.privileges.purchase_sub_menu_stock_transfer)) && (
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <ImportExportSharpIcon />
                </CardIcon>
                <p className={classes.cardCategory}>
                  {translate("Stock Transfer")}
                </p>
                <h3 className={classes.cardTitle}></h3>
              </CardHeader>
              <CardFooter stats>
                <Grid container>
                  <Grid item xs={12} sx={{ marginTop: "10px" }}>
                    <div className={classes.stats}>
                      <ArrowUpwardIcon />
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={(e) => props.changeView("OUT_LIST")}
                      >
                        {translate("Outgoing")}
                      </a>
                    </div>
                  </Grid>
                  <Grid item xs={12} sx={{ marginTop: "10px" }}>
                    <div className={classes.stats}>
                      <ArrowDownwardIcon />
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={(e) => props.changeView("IN_LIST")}
                      >
                        {translate("Incoming")}
                      </a>
                    </div>
                  </Grid>
                </Grid>
              </CardFooter>
            </Card>
          </Grid>
        )}
        {props.context.appType === "M_POS" &&
          props.context.privileges.purchase_sub_menu_manufacturing && (
            <Grid item xs={12} sm={6} md={4}>
              <Card>
                <CardHeader color="warning" stats icon>
                  <CardIcon color="warning">
                    <PrecisionManufacturingSharpIcon />
                  </CardIcon>
                  <p className={classes.cardCategory}>
                    {translate("Production")}
                  </p>
                  <h3 className={classes.cardTitle}></h3>
                </CardHeader>
                <CardFooter stats>
                  <Grid container>
                    <Grid item xs={13} sx={{ marginTop: "10px" }}>
                      <div className={classes.stats}>
                        <Add />
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            setShowProductionCrud(true);
                            setMode("create");
                            setFrom("dashboard");
                          }}
                        >
                          {translate("Production Stock Update")}
                        </a>
                      </div>
                    </Grid>
                    <Grid item xs={12} sx={{ marginTop: "10px" }}>
                      <div className={classes.stats}>
                        <ListIcon />

                        <a
                          style={{ cursor: "pointer" }}
                          onClick={(e) => props.changeView("ProductionList")}
                        >
                          {translate("Production History")}
                        </a>
                      </div>
                    </Grid>
                  </Grid>
                </CardFooter>
              </Card>
            </Grid>
          )}
      </Grid>
      <QuickPurchaseRequestWindow
        biRef={biRef}
        showMessage={props.showMessage}
        onRefresh={purchaseorderListRefresh}
        context={props.context}
        productCache={props.productCache}
      ></QuickPurchaseRequestWindow>
      <PurchaseRequestDraftWindow
        biRef={biRef}
        showMessage={props.showMessage}
        onRefresh={purchaseorderListRefresh}
        context={props.context}
        productCache={props.productCache}
      ></PurchaseRequestDraftWindow>
      <InventoryAdjustmentMultipleItem
        biRef={biRef}
        showMessage={props.showMessage}
        productCache={props.productCache}
        context={props.context}
      ></InventoryAdjustmentMultipleItem>
      {showProductionCrud && (
        <ProductionCrud
          from={from}
          mode={mode}
          showMessage={props.showMessage}
          productCache={props.productCache}
          context={props.context}
          setOpenWindow={setShowProductionCrud}
        ></ProductionCrud>
      )}
    </div>
  );
}
